<div class="d-inline-block" :class="options.class || ''" v-translate="{ html: options.text, extra: options.extra }"></div>